import Route from 'mewe/routes/route';

export default Route.extend({
  theme: 'group',

  beforeModel: function () {
    const groupId = this.paramsFor('app.group').group_id;
    this.dispatch('group', 'fetchCounters', groupId);
  },

  model: function () {
    return this.modelFor('app.group');
  },
});
